'use strict';

import 'phylotree/phylotree.css';

const $ = require('jquery');
const _ = require('underscore');
const d3 = require('d3');
const phylotree = require("phylotree");
const saveAs = require('filesaver.js');
const SVGtoPDF = require('svg-to-pdfkit');

// the global tree variable
var tree;

// the svg element
var svg = d3.select("#tree_display");

// the dictionary mapping node names to clusters
var clustering = {};

// the tree and annotation files
var newick_string;
var annotation_file;

//Container for the gradients
var defs = svg.append("defs");

//Code taken from http://stackoverflow.com/questions/9630008/how-can-i-create-a-glow-around-a-rectangle-with-svg
//Filter for the outside glow
var filter = defs.append("filter").attr("id","glow");

filter.append("feGaussianBlur").attr("class", "blur")
    .attr("stdDeviation","4.5").attr("result","coloredBlur");

var feMerge = filter.append("feMerge");
feMerge.append("feMergeNode").attr("in","coloredBlur");
feMerge.append("feMergeNode").attr("in","SourceGraphic");

// default scheme to color by - generated by https://medialab.github.io/iwanthue/
var coloring_scheme = d3.scale.ordinal().range(
		[ "#5526d1", "#85ec61", "#1a4ef7", "#e1d84a", "#ec932d", "#00bc5d",
				"#b25eff", "#7b9500", "#0133ab", "#42e856", "#ff43cb",
				"#2aeec0", "#ff0f40", "#00c78e", "#c20087", "#95e6a1",
				"#ff7df6", "#00702c", "#85a2ff", "#ff953e", "#0066cd",
				"#990b00", "#00c8bb", "#750062", "#bede9c", "#470058",
				"#d9d7a3", "#003178", "#ffa566", "#16579d", "#ff6886",
				"#006544", "#ffc5ff", "#4a3b00", "#b5a9ff", "#c9624b",
				"#00bbea", "#92003a", "#90e3d6", "#5b0049", "#b6d8f4",
				"#c40000", "#0097ad", "#ff7ca7", "#172929", "#ff9fd6",
				"#003c50", "#ffb29a", "#ae78aa", "#007a92", "#770043",
				"#522925" ]);

// this will be used to map bootstrap support values to edge thickness
var bootstrap_scale = d3.scale.linear().domain([ 0, 0.5, 0.7, 0.9, 0.95, 1 ])
		.range([ 1, 2, 3, 4, 5, 6 ]).interpolate(d3.interpolateRound);

function responsivefy(svg) {
  const container = d3.select(svg.node().parentNode),
      width = parseInt(svg.style('width'), 10),
      height = parseInt(svg.style('height'), 10),
      aspect = width / height;

  svg.attr('viewBox', `0 0 ${width} ${height}`)
      .attr('preserveAspectRatio', 'xMinYMid')
      .call(resize);

  d3.select(window).on(
      'resize.' + container.attr('id'),
      resize
  );

  function resize() {
      // calculate new width - subtract 15 to accommodate vertical scrollbar 
      const w = parseInt(container.style('width'));
      svg.attr('width', w);
      svg.attr('height', Math.round(w / aspect));
  }
}



/**
 * Styles the edges.
 * 
 * @param dom_element
 * @param edge_object
 */
function edgeStyler(dom_element, edge_object) {
	if ("bootstrap" in edge_object.target) {
		dom_element.style("stroke-width",
				bootstrap_scale(edge_object.target.bootstrap) + "pt");
	}
	dom_element
			.style(
					"stroke",
					"cluster" in edge_object.target ? coloring_scheme(edge_object.target.cluster)
							: null);
}

/**
 * Styles the nodes.
 * 
 * @param dom_element
 * @param node_object
 */
function nodeStyler(dom_element, node_object) {
	if (d3.layout.phylotree.is_leafnode(node_object)) {
		var node_label = dom_element.select("text");
		node_label.style("fill", coloring_scheme(node_object.cluster));
	}
}

/**
 * The default tree settings. This is what the tree is originally drawn with.
 */
function default_tree_settings() {
	tree = d3.layout.phylotree();
	tree.options({
		//'selectable': false,
		// turn off the menu on internal nodes
		'collapsible': false,
		// turn off d3 animations
		'transitions' : false,
		// turn off scale
		"show-scale" : false,
		'reroot' : false,
		'hide' : false,
		'brush' : false,
		// percentage of original size to display collapsed subtree
		'compression' : 0,
		// turn on zoom with mouse
		//'zoom' : true
	});
	tree.style_edges(edgeStyler);
	tree.style_nodes(nodeStyler);
	tree.align_tips(true); //set labels to even
	tree.radial(true); //use radial layout
	tree.selection_label("selected_clusters"); //set the selection name
	//tree.toggle_collapse = toggle_collapse;
    //tree.selection_callback(function(selection) {
    //    svg.call(responsivefy);
    //});
    //.size([height, width])
	//.node_circle_size(0); // do not show "circles" at internal nodes, if size is set > 0 it determines the size of the circle displayed*/
	tree.spacing_x(11, true);

	$("#layout_select").prop("checked", true);
	$("#display_nodes_select").prop("checked", true);
}


/**
 * Phylotree collapse handler
 */
function handleToggleCollapse(node) {
    tree.toggle_collapse(node).update();
    svg.call(responsivefy);
}

/**
 * Phylotree collapse menu handler
 */
function menuTitle(node) {
    return node.collapsed ? "Expand Subtree" : "Collapse Subtree";
}


// Helper function to determine whether node is internal
function isInternalNode(node) {
    return (node.children && node.children.length)
}


/**
 * Draws the tree using the default definitions and the tree file.
 * 
 * @param newick the tree file
 */
function drawATree(newick) {
	default_tree_settings();
	/* the next call creates the tree object, and tree nodes */
	tree(d3.layout.newick_parser(newick)).svg(svg).layout();
    // Add a custom menu item to the tree
    tree.get_nodes().filter(isInternalNode).forEach(function(node) {
        d3.layout.phylotree.add_custom_menu(node, menuTitle, function() {
            handleToggleCollapse(node);
        }, isInternalNode);
    });
}

/**
 * Enable button to swap between radial and linear
 */
$("#layout_select").on("click", function(e) {
	tree.radial($(this).prop("checked")).placenodes().update();
    
    // ensure the resulting tree is responsive
    svg.call(responsivefy);
});

/**
 * Enable button to show/hide circles on internal nodes.
 */
$("#display_nodes_select").on(
		"click",
		function(e) {
			($(this).prop("checked")) ? tree.node_circle_size(undefined) : tree
					.node_circle_size(0);
			tree.update();
            svg.call(responsivefy);
		});

/**
 * Enable filter (search) on the node attributes ``name`` and ``cluster``
 */
$("#branch_filter")
		.on(
				"input propertychange",
				function(e) {
					var filter_value = $(this).val();
					var rx = new RegExp(filter_value, "i");
					tree
							.modify_selection(
									function(n) {
										//tree.branch_name () - returns the node label, which the regex is then run against. We want to search this AND the node cluster attribute.
										return filter_value.length
												&& ((tree.branch_name()(
														n.target).search(rx)) != -1 || getNodeCluster(
														n.target).search(rx) != -1);
									}, "tag");
				});

/**
 * Get the node cluster value. This method is based on the function that defines ``phylotree.def_node_label``,
 * since it should return values under the same circumstances.
 *
 * @param {Node} node The node to get the cluster value for.
 * @returns The ``cluster`` value of the node.
 */
function getNodeCluster(node) {
	if (tree.options["internal-names"] || d3.layout.phylotree.is_leafnode(node)
			&& 'cluster' in node) {
		return node.cluster || "";
	}
	return "";
}

/**
 * Redraws the tree with the default layouts, resets all filter and display option values.
 */
$("#refresh").on("click", function(e) {
	loadTree();
	$("#branch_filter").val('').blur(); //clears the filter input
});


/**
 * Click handlers for pan and zoom in and zoom out
 */
var zoomfactor = 1;
var zoomincrement = 0.2;
var zoomlistener;
var drag = d3.behavior.drag().on("drag", function() {
    var t = d3.transform(d3.select('.phylotree-container').attr("transform"));
    const newx = t.translate[0] + d3.event.dx;
    const newy = t.translate[1] + d3.event.dy;
    d3.select('.phylotree-container').attr("transform", function(d,i) {
        return "translate(" + [ newx, newy ] + ") scale(" + t.scale + ")"
    });
}); 


/**
 * Function to return the current zoomlistener based on window size
 */
function getZoom() {
    var zl = d3.behavior.zoom().scaleExtent([0.1, 10])
        .on("zoom", function() {
            var t = d3.transform(d3.select('.phylotree-container').attr("transform"));
            d3.select('.phylotree-container').attr("transform", "translate(" + [t.translate[0], t.translate[1]] + ") scale(" + d3.event.scale + ")");
        });
    return zl;
}


/**
 * Function to write SVG styles from CSS as inline styles.  Needed to correctly serialize phylotree svg element.
 */
function cloneSVGWithStyling(ParentNode, OrigData){
    var ContainerElements = ["svg","g"];
    var RelevantStyles = {"rect":["fill","stroke","stroke-width"],
                          "path":["fill","stroke","stroke-width"],
                          "circle":["fill","stroke","stroke-width"],
                          "line":["stroke","stroke-width"],
                          "text":["fill","font-size","text-anchor"],
                          "polygon":["stroke","fill"]};
    var Children = ParentNode.childNodes;
    var OrigChildDat = OrigData.childNodes;

    for (var cd = 0; cd < Children.length; cd++){
        var Child = Children[cd];

        var TagName = Child.tagName;
        if (ContainerElements.indexOf(TagName) != -1){
            cloneSVGWithStyling(Child, OrigChildDat[cd])
        } else if (TagName in RelevantStyles){
            var StyleDef = window.getComputedStyle(OrigChildDat[cd]);
            var StyleString = "";
            for (var st = 0; st < RelevantStyles[TagName].length; st++){
                StyleString += RelevantStyles[TagName][st] + ":" + StyleDef.getPropertyValue(RelevantStyles[TagName][st]) + "; ";
            }
            Child.setAttribute("style",StyleString);
        }
    }
}


/**
 * Function to serialize an svg.
   Taken from:  https://observablehq.com/@mbostock/saving-svg
 */

function serialize($svg) {
    var _svg = $svg.cloneNode(true);
    cloneSVGWithStyling(_svg, $svg);
    const fragment = window.location.href + "#";
    const walker = document.createTreeWalker(_svg, NodeFilter.SHOW_ELEMENT, null, false);
    while (walker.nextNode()) {
        for (const attr of walker.currentNode.attributes) {
            if (attr.value.includes(fragment)) {
                attr.value = attr.value.replace(fragment, "#");
            }
        }
    }
    _svg.setAttributeNS("http://www.w3.org/2000/xmlns/", "xmlns", "http://www.w3.org/2000/svg");
    _svg.setAttributeNS("http://www.w3.org/2000/xmlns/", "xmlns:xlink", "http://www.w3.org/1999/xlink");
    const serializer = new window.XMLSerializer;
    const string = serializer.serializeToString(_svg);
    return new Blob([string], {type: "image/svg+xml"});
};


/**
 * Click handler for download SVG button
 */
export function saveAsSVG() {
    saveAs.saveAs(serialize(svg[0][0]), "tree.svg");
}

/**
 * Click handler for download Newick button
 */
export function saveAsTxt() {
		let blob = new Blob([newick_string], {type: "text/plain;charset=utf-8"});
    	saveAs.saveAs(blob, "tree.nwk");
}


/**
 * Click handler for download PDF button.  Uses pdfkit.js and svg-to-pdfkit.js on top of that.
 * blob-stream is used to stream pdf to a browser compatible blob
 */
export function saveAsPDF() {
    const w = $('#tree_display').width();
    const h = $('#tree_display').height();
    let doc = new PDFDocument({
        compress: false, size: [w, h]
    });
    let stream = doc.pipe(blobStream());
    SVGtoPDF(doc, svg[0][0], 0, 0, {
        useCSS: true,
        preserveAspectRatio: 'xMinYMid meet',
        width: w,
        height: h
    });
    doc.end();
    stream.on('finish', function() {
        let blob = stream.toBlob('application/pdf');
        saveAs.saveAs(blob, 'tree.pdf');
    });
}

/**
 * Creates the legend. Adds each group name to the list and color codes it
 * according to the cluster_colors. Adds the event listeners.
 * 
 * @param {D3.scale}
 *            coloring_scheme A D3 color scale.
 */
function createLegend(coloring_scheme) {
	// update the legend
	d3.select("#cluster-legend").selectAll("div").remove();
	//The sort order for the legend needs to be in ancient Greek alphabetical, but we're using
	//the English translations, so we need a custom sort method, which requires this big ugly array.
	var sort_array = ["Alphapapillomavirus", "Betapapillomavirus", "Gammapapillomavirus",
		"Deltapapillomavirus", "Epsilonpapillomavirus", "Zetapapillomavirus", "Etapapillomavirus",
		"Thetapapillomavirus", "Iotapapillomavirus", "Kappapapillomavirus", "Lambdapapillomavirus",
		"Mupapillomavirus", "Nupapillomavirus", "Xipapillomavirus", "Omikronpapillomavirus",
		"Pipapillomavirus", "Rhopapillomavirus", "Sigmapapillomavirus", "Taupapillomavirus",
		"Upsilonpapillomavirus", "Phipapillomavirus", "Chipapillomavirus", "Psipapillomavirus",
		"Omegapapillomavirus", "Dyodeltapapillomavirus", "Dyoepsilonpapillomavirus", "Dyozetapapillomavirus",
		"Dyoetapapillomavirus", "Dyothetapapillomavirus", "Dyoiotapapillomavirus", "Dyokappapapillomavirus",
		"Dyolambdapapillomavirus", "Dyomupapillomavirus", "Dyonupapillomavirus", "Dyoxipapillomavirus",
		"Dyoomikronpapillomavirus", "Dyopipapillomavirus", "Dyorhopapillomavirus", "Dyosigmapapillomavirus",
		"Dyotaupapillomavirus", "Dyoupsilonpapillomavirus", "Dyophipapillomavirus", "Dyochipapillomavirus",
		"Dyopsipapillomavirus", "Dyoomegapapillomavirus", "Treisdeltapapillomavirus",
		"Treisepsilonpapillomavirus", "Treiszetapapillomavirus", "Treisetapapillomavirus"];
	var cluster_colors = d3.select("#cluster-legend").selectAll(".col")
			.data(coloring_scheme.domain().sort(function(a, b) {
				var a_position = sort_array.indexOf(a);
				a_position = a_position >= 0 ? a_position : sort_array.length;
				var b_position = sort_array.indexOf(b);
				b_position = b_position >= 0 ? b_position : sort_array.length;
				return a_position - b_position;
			}).map(function(d) {
				return [ d ];
			}));
	cluster_colors.enter().append("div").classed("col-xxl-2 col-xl-3 col-lg-3 col-md-4 col-sm-6", true).append("div").classed("form-group form-check mb-0", true);
	cluster_colors.exit().remove();
	cluster_colors.filter(function(d) {
		return d.includes('undefined'); //this is caused by a data error, we don't actually want this in the legend...right?
	}).remove();
	
	cluster_colors = cluster_colors.selectAll(".form-group");
	cluster_colors = cluster_colors.selectAll("input").data(function(d) {
		return d;
	}).enter().append("input").classed("form-check-input", true).attr("type", "checkbox").attr("id", function(d) {
		return d;
	}).attr("onChange", "phylotreeBundle.updateSelection(this.id, this.checked)");

	cluster_colors
			.each(function(d) {
				d3
						.select(this.parentNode)
						.append("label")
						.classed("form-check-label", true)
						.text(d)
						.style("color", coloring_scheme(d), "important")
						.classed("cluster-text", true)
						.attr("for", d)
						.attr(
								"onmouseover",
								"phylotreeBundle.mouseovered(this.innerHTML, document.getElementById(this.getAttribute('for')).checked, true)")
						.attr(
								"onmouseout",
								"phylotreeBundle.mouseovered(this.innerHTML, document.getElementById(this.getAttribute('for')).checked, false)");
			});
}

/**
 * Apply the clustering annotation and color to the nodes and create the legend.
 * 
 * @param clustering the annotation file
 */
function applyAnnotation(clustering) {
	coloring_scheme.domain([]); // reset the coloring scheme
	if (tree) {
		tree.traverse_and_compute(function(node) {
			if (node.name in clustering) {
				node.cluster = clustering[node.name];
			// Protein id, i.e AaPV1-E1^E4, we only lookup the 1st half
			} else if (node.name.includes("-")) {
				let partial_node_name = node.name.split("-")[0];
				if (partial_node_name in clustering) {
					node.cluster = clustering[partial_node_name];
				}
			} else {
				delete node.cluster;
				var children_clusters = _.keys(_.countBy(node.children,
						function(d) {
							return d.cluster;
						}));
				if (children_clusters.length == 1 && children_clusters[0]) {
					node.cluster = children_clusters[0];
				}
			}
		}, "post-order");

		tree.update();

        // make element responsive
        svg.call(responsivefy);

		// update the legend
		createLegend(coloring_scheme);

        // set the zoom listener
        zoomlistener = getZoom();

        // set the pan callbacks
        d3.select('#tree_display').call(drag);

        // Attach the click handlers to make the buttons function
        $('#zoom-in').on('click', function() {
            zoomfactor = zoomfactor <= 10 - zoomincrement ? zoomfactor + zoomincrement : 10.0;
            zoomlistener.scale(zoomfactor).event(d3.select(".phylotree-container"));
        });
        $('#zoom-out').on('click', function() {
            zoomfactor = zoomfactor >= 0.1 + zoomincrement ? zoomfactor - zoomincrement : 0.1;
            zoomlistener.scale(zoomfactor).event(d3.select(".phylotree-container"));
        });
	}
}


/**
 * Displays a loading error if phylogenetic tree and/or annotations can't be downloaded
 */
function loadingError() {
    // put a loading error into the page
    $('#tree_display').parent().html('<p style="color:red;font-size:20pt;text-align:center">Error loading phylogenetic tree</p>')
    // Hide the tree control panel
    $('#tree-controls').hide();
}


/**
 * Reads the newick and annotation files and generates the tree and legend.
 * 
 * @param url the tree file
 */
function loadTreeFromURL(url) {
	d3.text(url, function(error, newick) {
        if(error) {loadingError();}
        else {
        	newick_string = newick;
        	loadTree();
        }
	});
}

/**
 * Generates the tree and legend.
 */
function loadTree() {
	drawATree(newick_string);
    loadAnnotationFromURL(annotation_file);
}

/**
 * Reads the annotation file and applies color to the tree and creates the legend.
 * 
 * @param url
 */
function loadAnnotationFromURL(url) {
	d3.csv(url, function(error, csv) {
		if(error) {loadingError();}
        else {applyAnnotation(csv[0]);}
	});
}

/**
 * Updates the selection. Will add or remove the cluster based on the current state.
 *
 * @param {String} cluster_name The name of the cluster to add/remove from the selection.
 * @returns The ``phylotree`` instance.
 */
export function updateSelection(cluster_name, select) {
	// Assume the whole group has the same setting as the first element in the group.
	if(getGroup(cluster_name)[0]["selected_clusters"] != select) {
	    return tree.modify_selection(getGroup(cluster_name), "selected_clusters");
	}
}

/**
 * Updates the selection only if the checkbox for the cluster isn't checked. Will add or remove
 * the cluster based on the current state.
 *
 * @param {String} cluster_name The name of the cluster to add/remove from the selection.
 * @param {boolean} checked The checked state of the checkbox.
 * @returns The ``phylotree`` instance.
 */
export function mouseovered(cluster_name, checked, select) {
	//only respond if the checkbox isn't selected
	//need to modify group only if it's changing, it will switch from true to false just by calling modify_selection
	if (!checked) {
		return updateSelection(cluster_name, select);
	}
}

/**
 * Gets all the nodes with cluster values that match the search value.
 *
 * @params {String} search_term A cluster name to look for.
 * @returns A list of all the nodes in the tree that have the search term as a cluster value.
 */
function getGroup(search_term) {
	var filtered_node = tree.get_nodes().filter(function(d) {
		if (d.cluster === search_term) {
			return d;
		}
	});
	return filtered_node;
}

/**
 * Call this method to generate the tree and legend.
 * 
 * @param tree the tree file
 * @param annotations the annotation file
 */
export function generateTree(tree, annotations) {
	annotation_file = annotations;
	loadTreeFromURL(tree);
}

export function generateTreeFromString(tree, annotations) {
	newick_string = tree;
	annotation_file = annotations;
	loadTree();
}
